import * as React from "react";
var backgroundSize = "100% 100%";
function getFrameSize(_a) {
    var frameBorderX = _a.frameBorderX, frameBorderY = _a.frameBorderY;
    var frameWidth = frameBorderX * 2;
    var frameHeight = frameBorderY * 2;
    return { frameWidth: frameWidth, frameHeight: frameHeight };
}
var QuestPlayFrameBackground = function (_a) {
    var children = _a.children, frameBorderX = _a.frameBorderX, frameBorderY = _a.frameBorderY;
    return (React.createElement("div", { style: {
            position: "absolute",
            left: frameBorderX,
            top: frameBorderY,
            right: frameBorderX,
            bottom: frameBorderY,
            backgroundColor: "black",
            opacity: 0.8,
        } }, children));
};
var QuestPlayFrameTiles = function (_a) {
    var frameBorderX = _a.frameBorderX, frameBorderY = _a.frameBorderY;
    var _b = getFrameSize({ frameBorderX: frameBorderX, frameBorderY: frameBorderY }), frameWidth = _b.frameWidth, frameHeight = _b.frameHeight;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: {
                position: "absolute",
                left: 0,
                top: 0,
                width: frameWidth,
                height: frameHeight * 3,
                backgroundImage: "url('/questplay/frame-left-top.png')",
                backgroundSize: backgroundSize,
            } }),
        React.createElement("div", { style: {
                position: "absolute",
                left: frameWidth,
                top: 0,
                width: frameWidth * 2,
                height: frameHeight,
                backgroundImage: "url('/questplay/frame-left-top-2.png')",
                backgroundSize: backgroundSize,
            } }),
        React.createElement("div", { style: {
                position: "absolute",
                left: frameWidth * 3,
                right: frameWidth * 3,
                top: 0,
                height: frameHeight,
                backgroundImage: "url('/questplay/frame-top.png')",
                backgroundSize: backgroundSize,
            } }),
        React.createElement("div", { style: {
                position: "absolute",
                right: frameWidth,
                top: 0,
                width: frameWidth * 2,
                height: frameHeight,
                backgroundImage: "url('/questplay/frame-right-top-2.png')",
                backgroundSize: backgroundSize,
            } }),
        React.createElement("div", { style: {
                position: "absolute",
                right: 0,
                top: 0,
                width: frameWidth,
                height: frameHeight * 3,
                backgroundImage: "url('/questplay/frame-right-top.png')",
                backgroundSize: backgroundSize,
            } }),
        React.createElement("div", { style: {
                position: "absolute",
                left: 0,
                top: frameHeight * 3,
                bottom: frameHeight * 3,
                width: frameWidth,
                backgroundImage: "url('/questplay/frame-left.png')",
                backgroundSize: backgroundSize,
            } }),
        React.createElement("div", { style: {
                position: "absolute",
                right: 0,
                top: frameHeight * 3,
                bottom: frameHeight * 3,
                width: frameWidth,
                backgroundImage: "url('/questplay/frame-right.png')",
                backgroundSize: backgroundSize,
            } }),
        React.createElement("div", { style: {
                position: "absolute",
                left: 0,
                bottom: 0,
                width: frameWidth,
                height: frameHeight * 3,
                backgroundImage: "url('/questplay/frame-left-bottom.png')",
                backgroundSize: backgroundSize,
            } }),
        React.createElement("div", { style: {
                position: "absolute",
                left: frameWidth,
                bottom: 0,
                width: frameWidth * 2,
                height: frameHeight,
                backgroundImage: "url('/questplay/frame-left-bottom-2.png')",
                backgroundSize: backgroundSize,
            } }),
        React.createElement("div", { style: {
                position: "absolute",
                left: frameWidth * 3,
                right: frameWidth * 3,
                bottom: 0,
                height: frameHeight,
                backgroundImage: "url('/questplay/frame-bottom.png')",
                backgroundSize: backgroundSize,
            } }),
        React.createElement("div", { style: {
                position: "absolute",
                right: frameWidth,
                bottom: 0,
                width: frameWidth * 2,
                height: frameHeight,
                backgroundImage: "url('/questplay/frame-right-bottom-2.png')",
                backgroundSize: backgroundSize,
            } }),
        React.createElement("div", { style: {
                position: "absolute",
                right: 0,
                bottom: 0,
                width: frameWidth,
                height: frameHeight * 3,
                backgroundImage: "url('/questplay/frame-right-bottom.png')",
                backgroundSize: backgroundSize,
            } })));
};
export var QuestPlayFrameImage = function (_a) {
    var children = _a.children, fitHeight = _a.fitHeight, frameBorderX = _a.frameBorderX, frameBorderY = _a.frameBorderY;
    return (React.createElement("div", { style: {
            width: "100%",
            height: fitHeight ? "100%" : undefined,
            position: "relative",
        } },
        React.createElement(QuestPlayFrameBackground, { frameBorderX: frameBorderX, frameBorderY: frameBorderY }),
        React.createElement("div", { style: {
                paddingLeft: frameBorderX,
                paddingTop: frameBorderY,
                paddingRight: frameBorderX,
                paddingBottom: frameBorderY,
                height: fitHeight ? "100%" : undefined,
            } }, children),
        React.createElement(QuestPlayFrameTiles, { frameBorderX: frameBorderX, frameBorderY: frameBorderY })));
};
/**
 * It renders children over the frame. This is needed for scroll to work
 */
export var QuestPlayFrameText = function (_a) {
    var children = _a.children, fitHeight = _a.fitHeight, frameBorderX = _a.frameBorderX, frameBorderY = _a.frameBorderY;
    var _b = getFrameSize({ frameBorderX: frameBorderX, frameBorderY: frameBorderY }), frameWidth = _b.frameWidth, frameHeight = _b.frameHeight;
    return (React.createElement("div", { style: {
            height: fitHeight ? "100%" : undefined,
            width: "100%",
            position: "relative",
            minHeight: 100,
        } },
        React.createElement(QuestPlayFrameBackground, { frameBorderX: frameBorderX, frameBorderY: frameBorderY }),
        React.createElement(QuestPlayFrameTiles, { frameBorderX: frameBorderX, frameBorderY: frameBorderY }),
        React.createElement("div", { style: {
                paddingLeft: frameWidth,
                paddingRight: frameWidth,
                paddingTop: frameHeight,
                paddingBottom: frameHeight,
                position: "relative",
                height: fitHeight ? "100%" : undefined,
            } }, children)));
};
//# sourceMappingURL=data:application/json;base64,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